<template>
    <div class="card">
        <div class="card-body">

            <div class="row">
                <div class="col-sm-7">
                    <h5 class="card-title" >
                        <span v-if="behavior != 'admin'">{{ quote.name }}</span>
                    <span v-if="quote.archived  && behavior == 'admin'" > (Archived)</span>
                    </h5>
                </div>
                <div class="col-sm-5">
                    <div class="col-sm-12 mt-4 text-right">
                        <button v-if="!quote.approved && !isConsultant" @click="deleteQ" type="button" class="btn btn-danger"
                            style="float: right; margin: 5px">
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>
                    <div  class="col-sm-12 mt-4 text-right">
                        <button v-if="!quote.approved" @click="aprove" type="button" class="btn btn-warning"
                            style="float: right; margin: 5px">
                            <i class="bi bi-check"></i>Accept quote
                        </button>
                    </div>

                    <div class="col-sm-12 mt-4 text-right">
                        <button v-if="!quote.approved && !quote.archived && behavior == 'admin'" @click="archive" type="button" class="btn btn-danger"
                            style="float: right; margin: 5px">
                            <i class="bi bi-archive">Archive</i>
                        </button>
                    </div>

                    <div v-if="quote.archived  && behavior == 'admin'" class="col-sm-12 mt-4 text-right">                        
                        <button  @click="unarchive" type="button" class="btn btn-info"
                            style="float: right; margin: 5px">
                            <i class="bi bi-unarchive">Unarchive</i>
                        </button>
                    </div>


                </div>
            </div>



            <div class="row mt-3">
                <div class="col-sm-3 negro">Created</div>
                <div class="col">{{ getCreatedDate }}</div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-3"></div>
                <div class="col">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="isTender">
                        <label class="form-check-label" for="flexCheckDefault"> Is Tender</label>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-sm-3 negro">
                    <h5 class="card-title">Items</h5>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="accordion accordion-flush" id="accordionFlushExample">

                        <div class="accordion-item" v-for="item in quote.items" :key="item.id">
                            <h2 class="accordion-header" :id="idAcordion(['heading', item.id.toString()])">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    :data-bs-target="idAcordion(['#', 'collapse', item.id.toString()])"
                                    aria-expanded="true" :aria-controls="idAcordion(['çollapse', item.id.toString()])">
                                    {{ item.name }}&nbsp;&nbsp;&nbsp;
                                    <b>${{ item.price }}</b>
                                </button>
                            </h2>
                            <div :id="idAcordion(['collapse', item.id.toString()])" class="accordion-collapse collapse"
                                :aria-labelledby="idAcordion(['heading', item.id.toString()])"
                                data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body">                                    
                                    <p v-if="item.idType != 100">{{ item.description }}</p>
                                    <div v-else>
                                        <button v-if="item.idType == 100"
                                            @click="verAssessment(item.idSource,item.name)" type="button"
                                            class="btn btn-secondary">
                                            <i class="bi bi-eye"></i> Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <filesQuote v-if="loaded" :idQuote="idQuote" :behavior="'user'" />
                </div>
            </div>

        </div>
    </div>


    <!------------------------------------------------------------------------------------------->
    <button style="display: none" type="button" class="btn btn-primary" data-bs-toggle="modal"
        data-bs-target="#mdlApprovedModal" id="btnOpenApprovedModal">
        Open
    </button>
    <div v-if="quote != null" class="modal fade" id="mdlApprovedModal" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Accept quote</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12 form-floating mb-3">
                            <textarea v-model="mdlApprove.comment" class="form-control"
                                placeholder="Leave a comment here" id="mdlComment" style="height: 100px"></textarea>
                            <label for="floatingTextarea">Comments</label>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <input class="form-check-input" type="radio" id="optUpload" v-model="mdlApprove.option"
                                value="upload" />
                            <label class="form-check-label" for="optUpload">
                                &nbsp;Upload purchase order
                            </label>
                        </div>
                    </div>

                    <div class="row mt-3" v-if="mdlApprove.option == 'upload'">
                        <div class="offset-sm-1 col-sm-11">
                            <input type="file" class="form-control" @change="handleFileUpload($event)" />
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-sm-12">
                            <input class="form-check-input" type="radio" id="optSign" v-model="mdlApprove.option"
                                value="sign" />
                            <label class="form-check-label" for="optSign">
                                &nbsp;Sign acceptance
                            </label>
                        </div>
                    </div>

                    <div class="row mt-3" v-if="mdlApprove.option == 'sign'">
                        <div class="offset-sm-1 col-sm-11">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="grdAccept"
                                    :checked="mdlApprove.accept" @change="mdlApprove.accept = !mdlApprove.accept" />
                                <label class="form-check-label" for="grdAccept">
                                    I accept the quote, terms and conditions
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3" v-if="mdlApprove.option == 'sign'">
                        <div class="offset-sm-1 col-sm-4">Type your name:</div>
                        <div class="col-sm-7">
                            <input class="form-control italicText" type="text" id="txtSign"
                                v-model="mdlApprove.signature" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <loadingbutton :loading="isLoading" @pressed="approved" :disabled="(!canAccept || isLoading)"
                        buttonText="Accept" />

                    <button id="btnCloseMdlApprove" type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>

    <quoteItem ref="quoteItemCmp"></quoteItem>

</template>
<script>
//import data from "../../helpers/data.json";
import loadingbutton from "../../components/global/loading-button.vue";
import filesQuote from "../../components/global/quote-files.vue";
import quoteItem from "../../components/global/quote-item.vue";

import vtc from "@/helpers/vtc.js";

export default {
    name: "quotenew-cmp",
    components: {
        loadingbutton,
        filesQuote: filesQuote,
        quoteItem
    },
    props: ["idQuote", "behavior"],
    data: function () {
        return {
            loaded: false,
            quote: { idServiceType: 0, idClient: 0, haveResume: false },
            mdlApprove: {
                comment: "",
                option: "",
                file: null,
                signature: "",
                accept: false,
                ip: "",
            },
            isLoading: false,
            buildingDiscount: "",
            isTender:false
        };
    },
    mounted() {
        let self = this;
        fetch("https://api.ipify.org?format=json")
            .then((x) => x.json())
            .then(({ ip }) => {
                self.mdlApprove.ip = ip;
            });
        if (this.idQuote != null && this.idQuote != 0) this.getQuoteInfo();
    },
    watch: {
        idQuote: function (newVal, oldVal) {
            console.log(newVal, oldVal);
            this.getQuoteInfo();
        },
        isTender:function(newVal, oldVal){
            console.log(newVal, oldVal);
            this.changeTender(newVal);
        }
    },
    methods: {
        idAcordion(arrr) {
            return arrr.toString().replace(/,/gi, '')
        },
        getQuoteInfo() {
            let self = this;
            this.$vtc
                .vtcFetch("/Quote/GetQuote/?id=" + this.idQuote, null, 'API2')
                .then(function (data) {
                    self.quote = data;
                    self.isTender = data.isTender
                    console.log("QUOTE", data);
                    //self.setResumeBuildings();
                    self.loaded = true;
                });
        },
        aprove() {
            document.getElementById("btnOpenApprovedModal").click();
        },

        async archive() {
            const res = await vtc.vtcFetch("/Quote/archive/?id=" + this.idQuote, null, 'API2')
            if(! res.error)
                this.quote.archived = true
        },

        async unarchive() {
            const res = await vtc.vtcFetch("/Quote/unarchive/?id=" + this.idQuote, null, 'API2')
            if(! res.error)
                this.quote.archived = false
        },

         async deleteQ() {
            if (this.isConsultant) return;

            const res = await vtc.vtcFetch("/Quote/Delete/?id=" + this.idQuote, null, 'API2')
            if(! res.error){
                alert('deleted')
                this.$router.push('/administration')
            }
                
        },


        approved() {
            this.isLoading = true;

            let self = this;
            const formData = new FormData();
            formData.append("idQ", this.idQuote);
            if (this.mdlApprove.option == "upload") {
                formData.append("file", this.mdlApprove.file);
            } else {
                formData.append("signature", this.mdlApprove.signature);
            }
            formData.append("comments", this.mdlApprove.comment);
            formData.append("ip", this.mdlApprove.ip);

            formData.append("idProject", this.quote.idProject);
            
            this.$vtc.vtcFetch("/Quote/Aprove/", formData, 'API2').then(
                function (data) {
                    console.log("Aprobado", data);

                    document.getElementById("btnCloseMdlApprove").click();
                    //self.$emit('accepted', self.idQuote)

                    self.$emit("accepted", data); //pass the new project created to reditect to.

                    self.isLoading = false;
                },
                function error(err) {
                    console.log("Aprobado error", err);
                    self.isLoading = false;
                }
            );
        },
        handleFileUpload(event) {
            this.mdlApprove.file = event.target.files[0];
        },

        verAssessment (id,name) {
            this.$refs.quoteItemCmp.open(id, name);
        },
        changeTender (tender){
            console.log("Tender",tender,this.isTender)
            let q = this.idQuote
            console.log("idQuote",q)
            this.$vtc.vtcFetch("/Quote/SetQuoteIsTender/?id="+q+"&t="+(tender?'true':'false'), null, 'API2').then(
                function (data) {
                    console.log("Set tender", data);
                },
                function error(err) {
                    console.log("Aprobado error", err);
                }
            );
        }
    },
    computed: {
        isConsultant() {
            return vtc.isConsultant();
        },
        leidoAssessment (){
        return this.idAssessment != 0;
        },
        getCreatedDate() {
            let d = new Date(this.quote.created);
            return this.$vtc.pasarFechaAYYYYMMDD(d, "-");
        },
        canAccept() {
            if (this.mdlApprove.option == "upload") {
                console.log("archivo", this.mdlApprove.file);
                return this.mdlApprove.file != null;
            } else {
                return this.mdlApprove.accept && this.mdlApprove.signature != "";
            }
        },
    }
}
</script>
